
import styles from './error.module.css';

export default function NotFound() {
    return (
        <div className={`${styles.errors} container`}>
            <h1>404</h1>
            <div className={styles.text_container}>
                <p>The page you are looking for does not exist.</p>
                <p>It might have been removed, had its name changed, or is temporarily unavailable.</p>
            </div>
        </div>
    );
}
